import { IMenuStyleData, MenuWidgetData } from "@pageBuilder/typings";
import { BaseItemsStylesRenderer } from "./base-items-styles-renderer";
import { CssProperties } from "../../../../models/css-property";

export class DividedItemsStyleRenderer extends BaseItemsStylesRenderer {

    public override render(element: HTMLElement, style: IMenuStyleData): void {
        const defaultPadding = MenuWidgetData.defaultMenuStyle.space ?? 20;
        super.render(element, style);

        const dividerProperties = this.getDividerProperties(style);
        if (style.space) {
            dividerProperties.add("padding-right", `${style.space / 2}px`);
        }

        if (dividerProperties.data.length > 0) {
            this.styleService.setStyle(element, this.getDividerSelector(element.id), dividerProperties.data);
        }

        const submenuSpaceProperties = new CssProperties();
        submenuSpaceProperties.tryAdd("padding-left", `${(style?.space ?? defaultPadding) / 2}px`);
        submenuSpaceProperties.tryAdd("padding-right", `${(style?.space ?? defaultPadding) / 2}px`);
        this.styleService.setStyle(element, this.getSubmenuSpaceSelector(element.id), submenuSpaceProperties.data);
    }

    private getDividerProperties(style: IMenuStyleData): CssProperties {
        const cssProperties = new CssProperties();
        if (style?.linkColorStyleData?.colorDefault) {
            cssProperties.add("border-right-color", style.linkColorStyleData?.colorDefault);
        }

        return cssProperties;
    }

    private getDividerSelector(id: string): string {
        return `#${id} .divider`;
    }

    private getItemLeftSelector(id: string): string {
        return `#${id} ul.root > li`;
    }

    private getSubmenuSpaceSelector(id: string): string {
        return `#${id} ul.submenu > li`;
    }

    public getStyleSpecificSelectors(id: string): Array<string> {
        return [
            this.getDividerSelector(id),
            this.getItemLeftSelector(id),
            this.getSubmenuSpaceSelector(id)
        ];
    }

}
